<template>
    <div class="statistics">
        <!-- 钻探数量统计饼图 -->
        <div class="taskPie" id="pie">

        </div>
        <!-- 钻孔数量统计柱状图 -->
        <div id="bar" class="bar">

        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
    props: {
        teamList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            
        }
    },
    watch: {
        teamList() {
            this.$nextTick(() => {
                this.createDrillBar()
                this.createTaskPie()
            })
        }
    },
    methods: {
        // 创建钻孔统计柱状图
        createDrillBar() {
            var chartDom = document.getElementById('bar');
            var myChart = echarts.init(chartDom);
            var option = {
                title: {
                    text: '施工队钻孔情况'
                },
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    bottom: '0%',
                    left: 'center'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    // type: 'category',
                    // data: data.map(item => {
                    //     return item.age
                    // }),
                    // interval: 8
                    type: 'value',
                    boundaryGap: [0, 1]
                },
                yAxis: {
                    type: 'category',
                    data: ['报告已提交', '施工已完成', '施工进行中', '未开始' ]
                },
                series: (() => {
                    // var colorArray = ['#4C62C2', '#FFC039', '#483d8b', '#708090', '#9932cc', '#ee82ee', '#20b2aa']
                    // var colorIndex = 0
                    var array = []
                    this.teamList.filter(team => {
                        let obj = {
                            name: team.deptName,
                            type: 'bar',
                            data: [team.zkDocCount, team.zkDoneCount, team.zkDoingCount, team.zkNotStartedCount],
                            itemStyle: {
                                color: "#85B243"
                            }
                        }
                        // colorIndex += 1
                        array.push(obj)
                    })
                    return array
                })()
            };
            option && myChart.setOption(option);
        },
        // 饼状图
        createTaskPie() {
            var chartDom = document.getElementById('pie');
            var myChart = echarts.init(chartDom);
            var option = {
                title: {
                    text: (()=> {
                        var countNum = 0
                        this.teamList.filter(team => {
                            countNum += team.zkCount
                        })
                        return countNum
                    })(),
                    subtext: '总数量',
                    left: 'center',
                    top: '37%',
                    textStyle: {
                        fontSize: 24,
                        color: "#686B73",
                        align: "center",
                    },
                    subtextStyle: {
                        fontFamily: "微软雅黑",
                        fontSize: 16,
                        color: "#686B73",
                    }
                },
                tooltip: {
                    trigger: 'item',
                    show: true,
                    formatter: '{b}<br />占比：{d}%<br />数量：{c}'
                },
                legend: {
                    bottom: '0%',
                    left: 'center'
                },
                series: [
                    {   
                        top: '0%',
                        name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: 40,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: (()=> { 
                            var unStartCount = 0
                            var doingCount = 0
                            var completeCount = 0
                            var reportCount = 0
                            this.teamList.filter(team => {
                                unStartCount += team.zkNotStartedCount
                                doingCount += team.zkDoingCount
                                completeCount += team.zkDoneCount
                                reportCount += team.zkDocCount
                            })
                            let unStart = { 
                                name: '未开始', 
                                value: unStartCount, 
                                itemStyle: {
                                    color: unStartCount == 0 ? '#EEEEEE' : '#CCCCCC'
                                }
                            }
                            let doing = { 
                                name: '施工进行中', 
                                value: doingCount,
                                itemStyle: {
                                    color: doingCount == 0 ? '#EEEEEE' : '#FBE59E'
                                }
                            }
                            let complete = { 
                                name: '施工已完成', 
                                value: completeCount,
                                itemStyle: {
                                    color: completeCount == 0 ? '#EEEEEE' : '#CEE55D'
                                }
                            }
                            let report = { 
                                name: '报告已提交', 
                                value: reportCount,
                                itemStyle: {
                                    color: reportCount == 0 ? '#EEEEEE' : '#85B243'
                                } 
                            }
                            return [unStart, doing, complete, report]
                        })()
                    }
                ]
            };
            option && myChart.setOption(option);
        }
    },
}
</script>
<style scoped>
    .statistics {
        width: 100%;
        height: 100%;
        overflow: auto;
    }
    .statistics .taskPie {
        width: calc(100% - 40px);
        height: 282px;
        padding: 20px;
        background: #fff;
        border-radius: 6px;
    }
    .statistics .bar {
        width: calc(100% - 40px);
        height: 426px;
        padding: 20px;
        background: #fff;
        border-radius: 6px;
        margin-top: 12px;
    }

    .title {
        color: black;
        
    }

    
</style>